import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { LEGAL_AREAS } from '../../../leads/legal-areas';
import { AdminAuthService } from '../../auth/admin-auth.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-admin-lead-requests',
  templateUrl: './admin-lead-requests.component.html',
  styleUrls: ['./admin-lead-requests.component.scss']
})
export class AdminLeadRequestsComponent implements OnInit {
  legalAreas = LEGAL_AREAS;
  isLoading = false;
  items: any[] = [];

  filters = {
    q: '',
    legal_area_slug: '',
    preferred_contact: '',
    status: 'pending'
  };

  constructor(
    private http: HttpClient,
    private authService: AdminAuthService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.fetch();
  }

  fetch(): void {
    this.isLoading = true;
    let params = new HttpParams();
    if (this.filters.q) params = params.set('q', this.filters.q);
    if (this.filters.legal_area_slug) params = params.set('legal_area_slug', this.filters.legal_area_slug);
    if (this.filters.preferred_contact) params = params.set('preferred_contact', this.filters.preferred_contact);
    if (this.filters.status) params = params.set('status', this.filters.status);

    this.http.get<any>(`${environment.apiBaseUrl}/admin/lead-requests`, { params }).subscribe(
      res => {
        this.items = res && res.data ? res.data : [];
        this.isLoading = false;
      },
      () => {
        this.isLoading = false;
        this.items = [];
      }
    );
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/admin/login']);
  }

  updateStatus(item: any, status: string): void {
    const msg = status === 'attended' ? '¿Marcar como atendido?' : '¿Revertir a pendiente?';
    if (!confirm(msg)) return;

    this.http.patch(`${environment.apiBaseUrl}/admin/lead-requests/${item.id}/status`, { status }).subscribe(
      () => {
        item.status = status;
        this.snackBar.open('Status actualizado', 'Cerrar', { duration: 3000 });
        this.fetch();
      },
      () => {
        this.snackBar.open('Error al actualizar status', 'Cerrar', { duration: 3000 });
      }
    );
  }
}

